import { forwardRef } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { ITextInput } from './TextInput.model';
import { StyledInput } from './TextInput.styled';

const TextInput = forwardRef<
	HTMLInputElement,
	ITextInput & React.InputHTMLAttributes<HTMLInputElement>
>(
	(
		{
			height,
			fontSize,
			textAlign,
			padding,
			active,
			error,
			activeBgColor = '#2D70DA',
			activeTextColor = '#ffffff',
			placeholderOpacity = 0.25,
			...props
		},
		ref,
	) => {
		return (
			<StyledInput
				{...props}
				style={{
					height: height,
					fontSize: fontSize,
					textAlign: textAlign,
					padding: padding,
					...props.style,
				}}
				tabIndex={props.tabIndex ?? -1}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
				$active={active}
				$error={error}
				$activeBgColor={activeBgColor}
				$activeTextColor={activeTextColor}
				$placeholderOpacity={placeholderOpacity}
				ref={ref}
			/>
		);
	},
);

export { TextInput };
